<template>
  <v-dialog
    :value="value"
    fullscreen
    transition="dialog-bottom-transition"
    content-class="zona-detalhe-dialog"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-toolbar dense flat>
        <v-toolbar-title>
          Detalhe por zona - {{ titulo }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="zona-detalhe-content">
        <v-text-field
          :value="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
          class="mb-4 zona-detalhe-search"
          @input="$emit('update:search', $event)"
        ></v-text-field>
        <v-row
          dense
          align="stretch"
          class="zona-detalhe-body"
        >
          <v-col cols="12" md="4" class="d-flex zona-detalhe-ranking-col">
            <v-card outlined class="pa-3 zona-ranking-card">
              <div class="d-flex align-center justify-space-between mb-2">
                <h4 class="subtitle-1 font-weight-medium mb-0">
                  Ranking por assessor
                </h4>
                <span class="caption grey--text">
                  {{ total }} cadastros
                </span>
              </div>
              <v-data-table
                :headers="rankingHeaders"
                :items="ranking"
                :options.sync="rankingOptions"
                :height="tableHeight"
                dense
                fixed-header
                no-data-text="Sem assessores nesta zona."
                class="zona-ranking-data-table"
              >
                <template v-slot:item.percentual="{ item }">
                  {{ item.percentual.toFixed(1) }}%
                </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-col cols="12" md="8" class="d-flex flex-column zona-detalhe-table-col">
            <v-data-table
              :headers="detalheHeaders"
              :items="items"
              :search="search"
              :options.sync="detalheOptions"
              :height="tableHeight"
              class="elevation-1 zona-detalhe-table"
              fixed-header
              no-data-text="Sem registros para esta zona."
            >
              <template v-slot:item.created_at="{ item }">
                {{ formatDateTime(item.created_at) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDateTime } from "../utils/formatters";

export default {
  name: "ZonaDetalheModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    titulo: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    ranking: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableHeight: "calc(80vh - 180px)",
      detalheHeaders: [
        { text: "ID", value: "idpessoa" },
        { text: "Nome Completo", value: "nome_completo" },
        { text: "Telefone", value: "telefone" },
        { text: "Email", value: "email" },
        { text: "Assessor", value: "assessor" },
        { text: "Zona", value: "zona" },
        { text: "Secao", value: "secao" },
        { text: "Data cadastro", value: "created_at" },
      ],
      rankingHeaders: [
        { text: "#", value: "posicao", align: "start", sortable: false },
        { text: "Assessor", value: "nome", align: "start" },
        { text: "Cadastros", value: "total", align: "end" },
        { text: "%", value: "percentual", align: "end" },
      ],
      detalheOptions: {
        sortBy: ["created_at"],
        sortDesc: [true],
        itemsPerPage: 25,
      },
      rankingOptions: {
        sortBy: ["posicao"],
        sortDesc: [false],
        itemsPerPage: 10,
      },
    };
  },
  methods: {
    formatDateTime,
  },
};
</script>

<style scoped>
.zona-detalhe-dialog ::v-deep .v-card {
  height: 100vh;
}

.zona-detalhe-dialog ::v-deep .v-card__text {
  height: calc(100vh - 96px);
  overflow: hidden;
}

.zona-detalhe-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.zona-detalhe-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  height: 100%;
}

.zona-detalhe-ranking-col {
  min-height: 0;
  overflow: hidden;
  max-width: 100%;
}

.zona-ranking-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.zona-ranking-data-table {
  max-width: 100%;
  overflow-x: auto;
}

.zona-ranking-data-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto !important;
  max-height: calc(100% - 59px) !important;
  overflow-x: auto !important;
}

.zona-ranking-data-table.v-data-table--dense td,
.zona-ranking-data-table.v-data-table--dense th {
  padding: 0 8px !important;
}

.zona-ranking-data-table ::v-deep .v-data-footer {
  position: sticky !important;
  bottom: 0 !important;
  background-color: white !important;
  border-top: thin solid rgba(0, 0, 0, 0.12) !important;
}

.zona-detalhe-table-col {
  min-height: 0;
}

.zona-detalhe-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto !important;
}
</style>
